import { useEffect, useState } from "react";
import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import Calling from "./api/Calling";
import { ToastContainer } from "react-toastify";
import Navbar1 from "./components/Navbar/Navbar1";
import Navbar2 from "./components/Navbar/Navbar2";
import Login from "./admin/Login/Login";
import Page404 from "./components/page/Page404";
import Logout from "./admin/Login/Logout";
import Error from "./admin/Login/Error";
import Home from "./admin/Home";
import User from "./admin/User/User";
import UserInfo from "./admin/User/UserInfo";
import LeaderBoard from "./admin/LeaderBoard/LeaderBoard";
import Controller from "./admin/Controller/Controller";
import NewPw from "./admin/Login/NewPw";
import NativeAds from "./admin/Ads/NavtiveAds/NativeAds";
import FullScreenAds from "./admin/Ads/FullScreenAds/FullScreenAds";
import BannerAds from "./admin/Ads/BannerAds/BannerAds";
import OpneAds from "./admin/Ads/OpenAds/OpneAds";
import RewardAds from "./admin/Ads/RewardAds/RewardAds";
import INSPACTLOOCK from "./components/INSPACTLOOCK";
import CashTask from "./admin/CashTask/CashTask";
import WithdrawInfo from "./admin/Withdraw/WithdrawInfo";
import Withdraw from "./admin/Withdraw/Withdraw";
import InhouseAds from "./admin/Ads/InHouseAds/InHouseAds";
import WithdrawCard from "./admin/Withdraw/WIthdrawCard";

function App() {
  const [isAuthorized, setIsAuthorized] = useState(null); // Initially null
  const navigate = useNavigate();

  const handleLoginStatusChange = (status) => {
    if (status) {
      setIsAuthorized(true);
    }
  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem("admin_box_dollar");
    navigate("/app-admin/panel/login");
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const adminToken = localStorage.getItem("admin_box_dollar");
        if (!adminToken) {
          setIsAuthorized(false);

          return;
        }

        const resp = await Calling.AdminAuthCheck();
        setIsAuthorized(resp.status);
      } catch (error) {
        console.log(error);
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  return (
    <div className="flex roboto-regular bg-main-bg">
      <ToastContainer />
      <INSPACTLOOCK />
      {isAuthorized && <Navbar1 />}
      <div className="flex ml-w-15 w-[100%]">
        {isAuthorized && <Navbar2 />}
        <Routes>
          {isAuthorized ? (
            <>
              <Route path="/" element={<Home />} />
              <Route
                path="/Logout"
                element={<Logout onLogout={handleLogout} />}
              />

              {/* Controller */}
              <Route path="/controller" element={<Controller />} />

              {/* User  */}
              <Route path="/manage/user/all/data" element={<User />} />
              <Route path="/manage/user/all/info/:id" element={<UserInfo />} />

              {/* Leaderboard */}
              <Route path="/manage/leaderboard" element={<LeaderBoard />} />

              {/* Native Ads */}
              <Route path="/manage/ads/nativeAds/add" element={<NativeAds />} />

              {/* FullScreenAds */}
              <Route
                path="/manage/ads/fullScreenAds/add"
                element={<FullScreenAds />}
              />

              {/* Banner Ads */}
              <Route path="/manage/ads/bannerAds/add" element={<BannerAds />} />

              {/* Open Ads */}
              <Route path="/manage/ads/openAds/add" element={<OpneAds />} />

              {/* Reward Ads */}
              <Route path="/manage/ads/rewardAds/add" element={<RewardAds />} />

              {/* Reward Ads */}
              <Route
                path="/manage/ads/inhouseads/add"
                element={<InhouseAds />}
              />

              {/* Admin Change Password*/}
              <Route path="/manage/changePw/" element={<NewPw />} />

              {/* Cash Task */}
              <Route path="/manage/cashtask" element={<CashTask />} />

              {/* WithDraw */}
              <Route path="/manage/withdraw" element={<Withdraw />} />
              <Route
                path="/manage/withdraw/info/:id"
                element={<WithdrawInfo />}
              />

              {/* Withdraw Card */}
              <Route path="/manage/withdrawcard" element={<WithdrawCard />} />

              <Route path="*" element={<Error />} />
            </>
          ) : (
            <>
              <Route
                path="/app-admin/panel/login"
                element={<Login onLogin={handleLoginStatusChange} />}
              />
              <Route path="*" element={<Page404 />} />
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}

export default App;
